/**
 * 検索窓付きSELECTBOX
 */
class SelectoboxSercher {
    constructor(wrapEl) {
        // element
        this.wrapEl    = wrapEl;
        this.valueEl 　= this.wrapEl.querySelectorAll('.ss-value')[0];
        this.displayEl = this.wrapEl.querySelectorAll('.ss-display')[0];
        this.boxEl     = this.wrapEl.querySelectorAll('.ss-box')[0];
        this.wordEl    = this.wrapEl.querySelectorAll('.ss-word')[0];
        this.listEl    = this.wrapEl.querySelectorAll('.ss-list')[0];

        // event
        this.displayEl.addEventListener('click', ev => {
            this.boxEl.style.display = 'block';
            this.wordEl.focus();
        });

        this.wordEl.addEventListener('keyup', () => {
            this.search();
        });

        Array.prototype.forEach.call(this.listEl.children, el => {
            el.children[0].addEventListener('click', () => {
                this.select(el.children[0]);
            });
        });

        document.addEventListener('click', ev => {
            if( ev.target == this.wrapEl || ev.target == this.displayEl || ev.target == this.boxEl || ev.target == this.wordEl || ev.target == this.listEl ){
            }else{
                this.boxEl.style.display = 'none';
            }
        });
    }

    search() {
        const keyword = this.wordEl.value;
        Array.prototype.forEach.call(this.listEl.children, list => {
            const name = list.children[0].dataset.name;
            const kana = list.children[0].dataset.kana;

            if( name.indexOf(keyword) !== -1 || kana.indexOf(keyword) !== -1 ){
                list.style.display = 'block';
            }else{
                list.style.display = 'none';
            }
        });
    }

    select(selectedEl) {
        // データセット
        this.valueEl.value = selectedEl.dataset.id;
        this.displayEl.value = selectedEl.dataset.name;
        // changeイベントを発生させる
        const changeEvent = new Event('change');
        this.valueEl.dispatchEvent(changeEvent);

        // 初期化
        this.boxEl.style.display = 'none';
        this.wordEl.value = '';
        Array.prototype.forEach.call(this.listEl.children, list => {
            list.style.display = 'block';
        });
    }
}

const selectoboxSercherEls = document.getElementsByClassName('selectbox-searcher');
if( selectoboxSercherEls ){
    Array.prototype.forEach.call(selectoboxSercherEls, selectoboxSercherEl => {
        const selectoboxSercher = new SelectoboxSercher(selectoboxSercherEl);
    });
}
